// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

const ce = Jsw.createElement;

const ActiveList = Class.create(Jsw.ActiveList, {
    _initConfiguration($super, config) {
        $super(config);
        this.domains = this._getConfigParam('domains', []);
    },

    itemCaptionHeadView($super, item) {
        const view = $super(item);
        const users = item.users.slice(0, 4);

        view.children.push(ce('.caption-summary',
            ce('.caption-summary-wrap',
                ce('span.summary-item',
                    ce('b', this.lmsg('hostLabel') + `${item.serverHost}${item.serverPort > 0 ? `:${item.serverPort}` : ''} (${item.typeTitle})`.escapeHTML()),
                    item.hasConnectionError ? [' ', ce('span.state-error', this.lmsg('serverUnavailable'))] : ''
                ),
                ce('span.summary-item',
                    item.users.length ? [
                        this.lmsg('users'),
                        ': ',
                        ce('b',
                            users
                                .map(({ id, login }) => `<a href="${this.urls['edit-user']}/id/${id}">${login}</a>`)
                                .join(', ') + (item.users.length > users.length ? ',&nbsp;...' : '')
                        ),
                    ] : [
                        ce('span.state-error', this.lmsg('noUsers')),
                        item.hasConnectionError ? '' : [' ', ce('a', { href: `${this.urls['create-user']}/database/${item.id}` }, `[${this.lmsg('addUser')}]`)],
                    ]
                ),
                item.hasConnectionError ? '' : ce('span.summary-item.ajax-loading', this.lmsg('calculatingSize'))
            )
        ));

        return view;
    },

    itemCaptionHeadWrapView($super, item) {
        const view = $super(item);

        if (item.allowWebadmin) {
            view.children.unshift(ce('span.caption-head-widget',
                ce('a.btn', { onclick: this.itemActions.openWebAdmin.bind(this, item) },
                    item.webAdminTitle
                )
            ));
        }

        const relatedDomains = this.domains
            .filter(({ lastDatabaseSelectedId }) => item.id === lastDatabaseSelectedId)
            .map(({ name }) => name);

        view.children.push(ce('span.caption-head-action',
            item.isUsedByApp ? (
                item.assignedDomainName ? this.lmsg('relatedToDomains', { domains: item.assignedDomainName }) : ''
            ) : (
                relatedDomains.length > 0 ? [
                    this.lmsg('relatedToDomains', { domains: relatedDomains.join(', ') }), ' ',
                    ce('a.toggler', { onclick: this.changeRelatedDomains.bind(this, item) }, this.lmsg('changeRelatedDomain')),
                ] : ce('a.toggler', { onclick: this.changeRelatedDomains.bind(this, item) }, this.lmsg('noRelatedDomains'))
            )
        ));

        if (!item.isUsedByApp) {
            view.children.push(ce('span.caption-head-action', { style: 'display: none;' },
                this.lmsg('relatedToDomains', { domains: '' }),
                ce('select',
                    ce('option', { value: '' }, this.lmsg('noDomainRelations')),
                    this.domains
                        .map(({ id, name, lastDatabaseSelectedId }) => ce(`option${item.id === lastDatabaseSelectedId ? '[selected]' : ''}`, { value: id }, name))
                ),
                ' ',
                ce('a.btn', { onclick: this.setRelatedDomains.bind(this, item) }, this.lmsg('buttonOk'))
            ));
        }
        return view;
    },

    render($super) {
        $super();

        new Ajax.Request(this.urls['list-size-data'], {
            method: 'get',
            onSuccess: ({ responseJSON }) => {
                responseJSON.forEach(item => {
                    const el = this.getItemElement(item);
                    const hostItemEl = el.down('.summary-item:first');
                    if (hostItemEl.down('.state-error')) {
                        return;
                    }
                    if (item.hasConnectionError) {
                        hostItemEl.insert(` <span class="state-error">${this.lmsg('serverUnavailable')}</span>`);
                        el.down('.summary-item:last').remove();
                    } else {
                        el.down('.summary-item:last').replace(
                            `<span class="summary-item">${this.lmsg('tables')}: <b>${item.tables}</b></span>` +
                            `<span class="summary-item">${this.lmsg('size')}: <b>${item.size}</b></span>`
                        );
                    }
                });
            },
        });
    },

    changeRelatedDomains(item) {
        const actions = this.getItemElement(item).select('.caption-head-action');
        actions[0].hide();
        actions[1].show();
    },

    setRelatedDomains(item) {
        const el = this.getItemElement(item);
        Jsw.redirectPost(this.urls['set-related-domain'], {
            id: item.id,
            domainId: el.down('.caption-head-action select').getValue(),
        });
    },
});

module.exports = ActiveList;



// WEBPACK FOOTER //
// ./app/database/active-list.js